module.exports = "/static/assets/fa1612f9c0474afcd38008ebc35cf735.png";